import React from "react";
import "../CampaignComponent/CampaginComponentCss/PanchayatSection.css";
 // replace with correct image

export default function PanchayatSection() {
  return (
    <section className="panchayat-section">
      <div className="panchayat-title-box">
        <h2 className="panchayat-title">
          मुख्यमंत्री समृद्ध पंचायत राज अभियान (२०२५–२६)
        </h2>
        <p className="panchayat-date">तारीख : 17/09/2025 - 31/12/2025 क्षेत्र: ग्रामविकास विभाग</p>
      </div>

      <div className="panchayat-content">
        <h3 className="panchayat-heading">महाराष्ट्र शासन<br/>ग्रामीणविकास व पंचायतराज विभाग<br/>जिल्हा परिषद, अहिल्यानगर</h3>

        <h4 className="panchayat-heading1">
          
            मुख्यमंत्री समृद्ध पंचायत राज अभियान (२०२५-२६)<br/>
          <span>(ग्रामविकास विभाग- शासन निर्णय- दिनांक ६ ऑगस्ट २०२५)</span>
        </h4>

        <p className="panchayat-text">
         पार्श्वभूमी:-राज्य शासनाच्या ग्रामविकास विभागाने “मुख्यमंत्री समृद्ध पंचायतराज अभियान” या महत्वाकांक्षी अभियानाच्या अंमलबजावणीचा निर्णय घेतला आहे. यामध्ये जिल्हा परिषद, पंचायत समिती आणि ग्रामपंचायतींना त्यांच्या कामगिरीनुसार प्रोत्साहित करून त्यांची कार्यक्षमता वाढविणे, त्यांना स्पर्धात्मक वातावरणातून नवीन उर्जा देणे, शासकीय योजनांची प्रभावी अंमलबजावणी करणे, योजनांचा लाभ ग्रामीण भागातील शेवटच्या घटकापर्यंत पोहोचविणे व त्यातून ग्रामीण भागातील लोकांचे जीवनमान उंचावणे या उद्देशाने ही योजना तयार करण्यात आली आहे. ग्रामपंचायतींमध्ये लोकसहभागाची चळवळ निर्माण करणे, ग्रामीण ग्रामस्थांना सुलभ रीतीने सेवा देणे, आरोग्य, शिक्षण, उपजीविका, सामाजिक न्याय या क्षेत्रांमध्ये ग्रामपंचायतींचा सहभाग वाढविणे, यासाठी सन २०२५-२६ या आर्थिक वर्षापासून “मुख्यमंत्री समृद्ध पंचायतराज अभियान” राबविण्यात येणार आहे.

        </p>
      </div>
    </section>
  );
}
